import { Box, Flex } from '@chakra-ui/react'
import ArrowRightOmens from 'components/svg/ArrowRightOmens'
import { H5 } from 'components/typography'
import Link from 'next/link'
import { FC } from 'react'

interface SlideCardProps {
  title: string
  href: string
}

export const SlideCard: FC<SlideCardProps> = ({ title, href }) => {
  return (
    <Link href={href}>
      <Flex
        px={{ base: '28px', lg: '32px' }}
        py={{ base: '28px', lg: '40px' }}
        borderRadius={{ base: '24px', lg: '32px' }}
        bg="rgba(246, 244, 232, 0.10)"
        backdropFilter="blur(24px)"
        h="100%"
        alignItems="center"
        justifyContent="space-between"
        gap={'24px'}
      >
        <Box>
          <H5 maxW="192px" color="alabaster">
            {title}
          </H5>
        </Box>
        <ArrowRightOmens fill="alabaster" boxSize="24px" />
      </Flex>
    </Link>
  )
}
